/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Empty_CtaInputs */

const en_blog_empty_cta = /** @type {(inputs: Blog_Empty_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a free account`)
};

const pl_blog_empty_cta = /** @type {(inputs: Blog_Empty_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Załóż darmowe konto`)
};

/**
* | output |
* | --- |
* | "Create a free account" |
*
* @param {Blog_Empty_CtaInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const blog_empty_cta = /** @type {((inputs?: Blog_Empty_CtaInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Empty_CtaInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_blog_empty_cta(inputs)
	return en_blog_empty_cta(inputs)
});